export const NotificationActionTypes = {
  CREATE_NOTIFICATION: 'CREATE_NOTIFICATION',
  DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION'
};

export const NotificationType = {
  error: 'alert round',
  success: 'success round',
  information: 'info',
  warning: 'warning',
  secondary: 'secondary'
};



// WEBPACK FOOTER //
// ./shared/common/redux/actions.notifications.types.js